import { gridTpl } from '../../../../common/grid/grid.controller';

export const employeesGrid = {
    bindings: {
        onSelect: '&'
    },
    controller: 'EmployeesGridController',
    ...gridTpl
};
